import React, { useState, useEffect } from 'react';
import { Form, Input, Select, Button, DatePicker, Typography } from 'antd';
import { UserOutlined, KeyOutlined, MailOutlined, MobileOutlined, TeamOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { action } from '../../store';
import { updateUser } from '../../actions/Authentication-action';
import moment from 'moment';
import './Profile.scss';

const { Title } = Typography;
const leftInput = { display: 'inline-block', width: 'calc(50% - 8px)' };
const rightInput = { display: 'inline-block', width: 'calc(50% - 8px)', margin: '0 8px' };
const fullInput = { display: 'inline-block', width: 'calc(100% - 8px)' }
const { Option } = Select;
const { TextArea } = Input;

const Profile = ({ userDetail }) => {

    const [form] = Form.useForm();
    const onFinish = values => {
        values.dob = values.dob.format("YYYY-MM-DD");
        values.email = userDetail.email;
        values.user_id = userDetail.user_id;
        action(updateUser(values));
        // console.log('Success:', values);
    };

    const onFinishFailed = errorInfo => {
        console.log('Failed:', errorInfo);
    };

    useEffect(() => {
        console.log((new Date(userDetail.dob) == "Invalid Date"), "userDetail")
        form.setFieldsValue({
            username: userDetail.name || '',
            phone: userDetail.contact || '',
            email: userDetail.email || '',
            dob: moment(userDetail.dob) || '',
            usernamelast: userDetail.last_name || '',
            mailing_address: userDetail.mailing_address || '',
            gender: userDetail.gender || '',
            social_identity: userDetail.social_identity || '',
            remember: true
        });

        // if (!(new Date(userDetail.dob) == "Invalid Date")) {
        //     form.setFieldsValue({
        //         dob: new Date(userDetail.dob)
        //     })
        // }

    }, [userDetail.name]);

    // console.log(initialValues, "initialValues");
    return (
        <>
            <div className="site-layout-background" style={{ padding: 24 }}>
                <Title level={5} style={{ textAlign: 'center', backgroundColor: '#87d068', textTransform: "uppercase", margin: "-24px -24px 24px -24px", padding: "5px 0", color: "white" }}>Your Profile Information</Title>
                <Form
                    name="basic"
                    // initialValues={initialValues}
                    form={form}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                >
                    <Form.Item>
                        <Input.Group compact>
                            <Form.Item
                                name="username"
                                rules={[{ required: true, message: 'Please input your first name!' }]}
                                style={leftInput}
                            >
                                <Input placeholder="First Name" prefix={<UserOutlined />} />
                            </Form.Item>
                            <Form.Item
                                name="usernamelast"
                                rules={[{ required: true, message: 'Please input your last name!' }]}
                                style={rightInput}
                            >
                                <Input placeholder="Last Name" prefix={<UserOutlined />} />
                            </Form.Item>
                        </Input.Group>

                        <Input.Group >
                            <Form.Item
                                name="email"
                                rules={[{ required: true, message: 'Please input your email address!' }]}
                                style={leftInput}
                            >
                                <Input disabled={true} prefix={<MailOutlined />} placeholder="Email Address" />
                            </Form.Item>
                             <Form.Item
                                name="password"
                                rules={[{ disabled: true }]}
                                disabled={true}
                                style={rightInput}
                            >
                                <Input.Password disabled={true} prefix={<KeyOutlined />} placeholder="*****" />
                            </Form.Item>
                        </Input.Group>
                        <Input.Group compact>
                            <Form.Item
                                name="phone"
                                rules={[{  message: 'Please input your phone number!' }]}
                                style={leftInput}
                            >
                                <Input prefix={<MobileOutlined />} placeholder="Phone Number" />
                            </Form.Item>
                            <Form.Item
                                name="dob"
                                rules={[{ required: true, message: 'Please input your date of birth!' }]}
                                style={rightInput}
                            >
                                <DatePicker placeholder="Date of Birth" maxDate={moment().subtract(18, "years")} />
                            </Form.Item>
                        </Input.Group>
                        <Input.Group compact>

                            <Form.Item
                                name="gender"
                                rules={[{ required: true, message: 'Please select your gender!' }]}
                                style={leftInput}
                            >
                                <Select placeholder="Select Gender">
                                <Option value="Female">Female</Option>
                                    <Option value="Male">Male</Option>
                                    <Option value="Third Gender">Third Gender</Option>
                                </Select>
                            </Form.Item>
                            <Form.Item
                                name="social_identity"
                                rules={[{ required: true, message: 'Please input your social identity!' }]}
                                style={rightInput}
                            >
                                <Input placeholder="Social Identity (race, ethnicity, etc" />
                            </Form.Item>
                        </Input.Group>

                        <Input.Group>
                            <Form.Item
                                name="mailing_address"
                                rules={[{ required: true, message: 'Please enter the mailing address' }]}
                                style={fullInput}
                            >
                                <TextArea rows={4} placeholder="Mailing Address" />

                            </Form.Item>
                        </Input.Group>

                    </Form.Item>


                    <Form.Item className="text-center">
                        <Button type="primary" htmlType="submit" className="submit-cta" >
                            Update Profile
                            </Button>
                    </Form.Item>
                </Form>
            </div>
        </>
    )
}
export default Profile